.cell {
  float: left;
  padding: 0.65rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0pvYkNvbmZpZ1RlbXBsYXRlcyIsInNvdXJjZXMiOlsiY2xhc3Nlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuY2VsbCB7XG4gIGZsb2F0OiBsZWZ0O1xuICBwYWRkaW5nOiAwLjY1cmVtO1xufVxuIl19 */